import React from "react";
import "./Spinner.css"; // CSS file import

const Spinner = () => {
  return <div className="spinner"></div>;
};

export default Spinner;
